/**
 * Pure date utility functions for CdpPayCalendar
 * No dependencies on external state or services
 */

import moment from 'moment';

/**
 * Format a date for calendar display
 * @param {string|Date} date - Date to format
 * @returns {string} Formatted date string
 */
export const formatCalendarDate = (date) => {
  return moment(date).format('YYYY-MM-01');
};

/**
 * Get the start and end dates for a given month
 * @param {string|Date} date - Date within the month
 * @returns {Object} { startDate, endDate }
 */
export const getMonthRange = (date) => {
  const startDate = moment(date).startOf('month').format('YYYY-MM-DD');
  const endDate = moment(date).endOf('month').format('YYYY-MM-DD');
  return { startDate, endDate };
};

/**
 * Check if a date is current or past month
 * @param {string|Date} date - Date to check
 * @returns {boolean} True if date is current or past month
 */
export const isCurrentOrPastMonth = (date) => {
  const currentMonth = moment().format('YYYY-MM-01');
  const checkDate = moment(date).format('YYYY-MM-01');
  return currentMonth >= checkDate;
};

/**
 * Get month and year from date
 * @param {string|Date} date - Date to extract from
 * @returns {Object} { month, year }
 */
export const getMonthYear = (date) => {
  return {
    month: moment(date).format('MM'),
    year: moment(date).format('YYYY')
  };
};

/**
 * Parse month and year from route params
 * @param {Object} params - Route params object
 * @returns {string} Formatted start date (YYYY-MM-01)
 */
export const parseStartDateFromParams = (params) => {
  if (params.year && params.month) {
    return moment(`${params.year}-${params.month}`, 'YYYY-MM').format('YYYY-MM-01');
  }
  return moment().format('YYYY-MM-01');
};
